import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { DateTime } from 'luxon';
import { StoreService } from 'core/services/store.service';
import { CoursesService, License, Course } from '../../core';
import { LicenseSessionsService } from '../services/license-sessions.service';
import { LicensesLogService } from './licenses-log.service';

@Component({
  selector: 'lms-license-log',
  templateUrl: './license-log.component.html',
  styleUrls: ['./license-log.component.scss'],
  providers: [LicensesLogService]
})
export class LicenseLogComponent implements OnInit, OnChanges {
  @Input() public license: License;
  @Input() public course: Course;
  @Input() public showToolbar: boolean = true;

  public started = false;

  public listId: string;
  public sessionResumes: any[];
  public durationOffset = new Date(0).getTimezoneOffset() * 60000;
  public gameColumns: any[];
  public filters = {};
  public dataSource: any;
  public toolbarConfig: any;
  public listOptions: any;
  public format = DateTime.DATETIME_MED_WITH_SECONDS;

  constructor(
    public logService: LicenseSessionsService,
    private coursesService: CoursesService,
    public licensesLogService: LicensesLogService
  ) {}

  ngOnInit() {
    this.listId = this.logService.LICENSE_LOG_ID + '_' + Date.now();
    this.toolbarConfig = {
      list: {
        listId: this.listId,
        download: false,
        filterRow: false,
        columnChooser: false,
        skeletor: true
      }
    };
  }

  async ngOnChanges() {
    this.filters = { licenseId: this.license.id };
    this.listOptions = { filters: this.filters };
    this.dataSource = await this.licensesLogService.getDatasource(this.listId, this.listOptions, this.license);
  }

  setCollection(sessionResumes) {
    this.sessionResumes = sessionResumes;
  }

  onDatasourceUpdate(dataSource) {
    this.dataSource = dataSource;
    StoreService.update(this.listId, this.dataSource);
  }
}
